import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../../styles';

const useStyles = createUseStyles(
  {
    imgContainer: {
      height: 160,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: 8,

      '& img': {
        maxWidth: '100%',
        objectFit: 'contain',
        verticalAlign: 'top',
        display: 'inline-block',
      },
    },

    footerButtons: {
      fontSize: 14,
      margin: '16px 0',
      padding: 8,
      width: '100%',
      border: '1px solid var(--x-accent-1-1)',
    },

    downloadBtn: {
      fontWeight: FontWeight.SemiBold,
      fontSize: 14,
      lineHeight: '24px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',

      '&:hover': {
        border: '1px solid #740574',
      },
    },
  },
  {
    name: 'download-widget',
  },
);

export default useStyles;
